export default "__VITE_ASSET__3PSr4klg__"